import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import { useMemo, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { FieldValidationType } from '../../../sic-lib/enums/FieldValidationType';
import MenuSetChannelRaw from './MenuSetChannelRaw/MenuSetChannelRaw';

const useStyles = makeStyles()((theme: Theme) => ({
    btnSms: {
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
}));

interface ComponentState {
    buttonIcon: any;
    buttonText: string;
}

interface Props {
    selected: FieldValidationType;
    onSelectHandler: React.Dispatch<{ fieldType: FieldValidationType }>;
}

export default function MenuSetChannel({ selected, onSelectHandler }: Props) {
    const { classes } = useStyles();
    const [menuId] = useState<string>('menu_set_channel');
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const compState = useMemo(() => {
        switch (selected) {
            case FieldValidationType.email:
                return {
                    buttonIcon: <EmailIcon />,
                    buttonText: 'Email',
                } as ComponentState;
            case FieldValidationType.usMobilePhone:
                return {
                    buttonIcon: <SmsIcon />,
                    buttonText: 'SMS',
                } as ComponentState;
            default:
                return {
                    buttonIcon: null,
                    buttonText: 'Select channel',
                } as ComponentState;
        }
    }, [selected]);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                //className={classes.btnSms}
                aria-controls="channels_menu"
                aria-haspopup="true"
                startIcon={compState.buttonIcon}
                endIcon={<ArrowDropDownIcon />}
                onClick={handleOpen}
                variant="outlined"
            >
                {compState.buttonText}
            </Button>
            <MenuSetChannelRaw
                menuId={menuId}
                anchorEl={anchorEl}
                selected={selected}
                onSelectHandler={onSelectHandler}
                onCloseHandler={handleClose}
            />
        </>
    );
}
